import { GenericObject } from '@synergy/models';
import deepMerge from 'deepmerge';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const mergeSearchParams = (baseObject: GenericObject, diffObject: GenericObject = {}): GenericObject => {
    diffObject = recursiveUpdateDiffObjectForArrays(baseObject, diffObject);

    return deepMerge(baseObject, diffObject, {
        // Always use new array if applicable since we converted array beforehand
        arrayMerge: (source, destination) => (destination ? destination : source),
    });
};

const recursiveUpdateDiffObjectForArrays = (object: GenericObject, collection: GenericObject) => {
    Object.keys(object).forEach(key => {
        const value = object[key];
        if (value) {
            if (value !== null && typeof value === 'object' && !Array.isArray(value) && collection[key]) {
                recursiveUpdateDiffObjectForArrays(value, collection[key]);
            } else if (Array.isArray(value)) {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                let previousArray = object[key].slice() as any[] | null;
                if (
                    collection[key] !== null &&
                    typeof collection[key] === 'object' &&
                    !Array.isArray(collection[key])
                ) {
                    Object.keys(collection[key]).forEach(index => {
                        if (previousArray) {
                            previousArray.splice(parseInt(index, 10), 1);
                        }
                    });
                } else if (Array.isArray(collection[key])) {
                    previousArray = collection[key];
                } else if (collection[key] === null) {
                    previousArray = null;
                }
                collection[key] = previousArray;
            }
        }
    });

    return collection;
};
